import {BehaviorSubject, Subject} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable()
export class LoaderService {
  loadChange = new Subject<any>();

  // A BehaviorSubject is an Observable with a default value
  isLoading: Subject<boolean> = new BehaviorSubject(false);
  constructor() {}
}
